import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsConfig from "components/Dashboard/Forms/Config";

export default function DashboardFormConfig(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={""}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsConfig />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}